
import NoFound from "../page/NoFound/NoFound";
import LoginView from "../page/LoginView/LoginView";


const routes = [
  {
    path: "/",
    redirect: 'home',
    component: () => import('../page/Home/HomeView'),
    children: [
      {
        path: "home",
        name: "首页",
        component: () => import('../page/Home/HomeView'),
      },
    ],
  },

  {
    path: "/User",
    name: '用户',
    component: () => import('../page/User/index.vue'),
    children: [
      {
        path: "Manage",
        name: "管理",
        component: () => import('../page/User/Manage/Index.vue'),
        children: [
          {
            path: "Activity",
            name: "活动",
            component: () => import('../page/User/Manage/Activity/Index.vue'),
            children: [
              {
                path: "",
                name: "活动发布",
                component: () => import('../page/User/Manage/Activity/Home.vue'),
              },
              {
                path: "Create",
                name: "创建活动",
                component: () => import('../page/User/Manage/Activity/Create.vue'),
              },
              {
                path: "Upload",
                name: "上传",
                component: () => import('../page/User/Manage/Activity/Upload.vue'),
              },
              {
                path: "MeettingTicket",
                name: "编辑活动门票",
                component: () => import('../page/User/Manage/Activity/MeettingTicket.vue'),
              },
              {
                path: "BaseInfo",
                name: "活动简介",
                component: () => import('../page/User/Manage/Activity/BaseInfo.vue'),
              },
              {
                path: "InteractionSetting",
                name: "互动设置",
                component: () => import('../page/User/Manage/Activity/InteractionSetting.vue'),
              },
              {
                path: "InviteList",
                name: "邀请榜",
                component: () => import('../page/User/Manage/Activity/InviteList.vue'),
              },
              {
                path: "CooperateApply",
                name: "合作申请",
                component: () => import('../page/User/Manage/Activity/CooperateApply.vue'),
              },
              {
                path: "BindGroup",
                name: "设置圈子",
                component: () => import('../page/User/Manage/Activity/BindGroup.vue'),
              },
            ]
          },
          {
            path: "Live",
            name: "直播",
            component: () => import('../page/User/Manage/Live/Index.vue'),
          },
          {
            path: "Course",
            name: "课程",
            component: () => import('../page/User/Manage/Course/Index.vue'),
            children: [
              {
                path: "",
                name: "课程列表",
                component: () => import('../page/User/Manage/Course/Home.vue'),
              },
              {
                path: "Create",
                name: "创建课程",
                component: () => import('../page/User/Manage/Course/Create.vue'),
              },
              {
                path: "Upload",
                name: "课程修改",
                component: () => import('../page/User/Manage/Course/Upload.vue'),
              },
            ]
          },


          {
            path: "PlayLet",
            name: "短剧",
            component: () => import('../page/User/Manage/PlayLet/Index.vue'),
            children: [
              {
                path: "",
                name: "短剧列表",
                component: () => import('../page/User/Manage/PlayLet/Home.vue'),
              },
              {
                path: "CreatePrev",
                name: "提交资质",
                component: () => import('../page/User/Manage/PlayLet/CreatePrev.vue'),
              },
              {
                path: "Create",
                name: "创建短剧",
                component: () => import('../page/User/Manage/PlayLet/Create.vue'),
              },
              {
                path: "Directory",
                name: "剧集管理",
                component: () => import('../page/User/Manage/PlayLet/Directory.vue'),
              },
            ]
          },
          {
            path: 'Promote',
            name: '星推官',
            component: () => import('../page/User/Manage/Promote/Index.vue'),
            children:[
              {
                path: "",
                name: "星推官查询",
                component: () => import('../page/User/Manage/Promote/Search.vue'),
              },
            ]
          },
          {
            path: 'Test',
            name: '测试',
            component: () => import('../page/User/Manage/Test/Index.vue'),
            children:[
              {
                path: "",
                name: "测试使用",
                component: () => import('../page/User/Manage/Test/Test.vue'),
              },
            ]
          },
          {
            path: "Shop",
            name: "商品",
            component: () => import('../page/User/Manage/Shop/Index.vue'),
            children: [
              {
                path: "",
                name: "商品管理",
                component: () => import('../page/User/Manage/Shop/ProductManage.vue'),
              },
              {
                path: "AddProduct",
                name: "添加商品",
                component: () => import('../page/User/Manage/Shop/Add.vue'),
                children: [
                  {
                    path: "",
                    name: " ",
                    component: () => import('../page/User/Manage/Shop/AddProduct.vue'),
                  },
                  {
                    path: "DeliveryTemplate",
                    name: "运费模板",
                    component: () => import('../page/User/Manage/Shop/Delivery.vue'),
                    children: [
                      {
                        path: "",
                        name: " ",
                        component: () => import('../page/User/Manage/Shop/DeliveryTemplate.vue'),
                      },
                      {
                        path: "AddTemplate",
                        name: "新增模板",
                        component: () => import('../page/User/Manage/Shop/AddTemplate.vue'),
                      },
                    ]
                  },
                ]
              },
              {
                path: "ProductEvaluate",
                name: "评价管理",
                component: () => import('../page/User/Manage/Shop/ProductEvaluate.vue'),
              },
            ]
          },
          {
            path: "WattingHandle",
            name: "待处理",
            component: () => import('../page/User/Manage/WattingHandle/WattingHandle.vue'),
          },
          {
            path: "OrderList",
            name: "订单列表",
            component: () => import('../page/User/Manage/OrderList/Index.vue'),
            children: [
              {
                path: "",
                name: "列表",
                component: () => import('../page/User/Manage/OrderList/OrderList.vue'),
              },
            ]
          },
          {
            path: "EvaluateManage",
            name: "评价数据",
            component: () => import('../page/User/Manage/EvaluateManage/Index.vue'),
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/EvaluateManage/EvaluateManage.vue'),
              },
              {
                path: "BadEvaluate",
                name: "待处理差评",
                component: () => import('../page/User/Manage/EvaluateManage/BadEvaluate.vue'),
              },
              {
                path: "CheckEvaluate",
                name: "待查看评价",
                component: () => import('../page/User/Manage/EvaluateManage/CheckEvaluate.vue'),
              }
            ]
          },
          {
            path: "SendGoods",
            name: "发货",
            component: () => import('../page/User/Manage/SendGoods/index.vue'),
            children: [
              {
                path: "",
                name: "首页",
                component: () => import('../page/User/Manage/SendGoods/SendGoods.vue'),
              },
              {
                path: "ProductsDetail",
                name: "查看详情",
                component: () => import('../page/User/Manage/SendGoods/ProductsDetail.vue'),
              },
              {
                path: "DeliveryInformation",
                name: "查看物流详情",
                component: () => import('../page/User/Manage/SendGoods/DeliveryInformation.vue'),
              },
            ]
          },
          {
            path: "AfterSales",
            name: "售后订单",
            component: () => import('../page/User/Manage/AfterSales/Index.vue'),
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/AfterSales/AfterSales.vue'),
              }, {
                path: "Detail",
                name: "查看详情",
                component: () => import('../page/User/Manage/AfterSales/Detail.vue'),
              },]
          },
          {
            path: "Apply",
            name: "入驻申请",
            component: () => import('../page/User/Manage/Apply/ApplyView.vue'),
          },
          {
            path: "PlatForm",
            name: "订单管理",
            component: () => import('../page/User/Manage/PlatForm/OrderList.vue'),
          },
          {
            path: "IncomeDetail",
            component: () => import('../page/User/Manage/Income/IncomeDetail/IndexView.vue'),
            name: "收益明细",
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/Income/IncomeDetail/AllIncome.vue'),
              },
              {
                path: "WithdrawalOrders",
                name: "可提现订单",
                component: () => import('../page/User/Manage/Income/IncomeDetail/WithdrawalOrders.vue'),
              },
            ]
          },
          {

            path: "DataIncome",
            name: "数据与收益",
            component: () => import('../page/User/Manage/DataIncome/Index.vue'),
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/DataIncome/DataIncome.vue'),
              },
              {
                path: "ProductsTotal",
                name: "商品总数",
                component: () => import('../page/User/Manage/DataIncome/ProductsTotal.vue'),
              },
              {
                path: "TodayOrders",
                name: "今日订单",
                component: () => import('../page/User/Manage/DataIncome/TodayOrders.vue'),
              },
              {
                path: "TodayIncome",
                name: "今日收益",
                component: () => import('../page/User/Manage/DataIncome/TodayIncome.vue'),
              },
            ]
          },
          {
            path: "WithdrawalRecord",
            name: "提现记录",
            component: () => import('../page/User/Manage/Income/WithdrawalRecord.vue'),

          },
          {
            path: "OrderDetail",
            name: "订单明细",
            component: () => import('../page/User/Manage/OrderDetail/Index.vue'),

          },
          {

            path: "SelectionHall",
            name: "选品大厅",
            component: () => import('../page/User/Manage/SelectionHall/Index.vue'),
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/SelectionHall/SelectionHall.vue'),
              },
              {
                path: "PhysicalGoods",
                name: "商品",
                component: () => import('../page/User/Manage/SelectionHall/PhysicalGoods.vue'),
              },
              {
                path: "MyShop",
                name: "我的小店",
                component: () => import('../page/User/Manage/SelectionHall/MyShop.vue'),
              },
              {
                path: "ProductDetail",
                name: "商品详情",
                component: () => import('../page/User/Manage/SelectionHall/ProductDetail.vue'),
              },
            ]
          },
          {

            path: "BroadcastGoodsManage",
            name: "直播商品管理",
            component: () => import('../page/User/Manage/BroadcastGoodsManage/Index.vue'),
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/BroadcastGoodsManage/BroadcastGoodsManage.vue'),
              },
            ]
          },
          {

            path: "CustomerService",
            name: "商家客服",
            component: () => import('../page/User/Manage/CustomerService/Index.vue'),
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/CustomerService/CustomerService.vue'),
              },
            ]
          },
          {
            path: "Chat",
            name: "消息",
            component: () => import('../page/User/Manage/Chat/Index.vue'),
            children: [
              {
                path: "",
                name: " ",
                component: () => import('../page/User/Manage/Chat/Chat.vue'),
              },
              {
                path: "TicketManage",
                name: "报名设置",
                component: () => import('../page/User/Manage/Chat/TicketManage.vue'),
              },
            ]
          },
        ],
      },


      {
        path: "MyCoupon",
        name: '我的卡券',
        component: () => import('../page/User/MyCoupon/Index.vue'),
        children: [
          {
            path: "Voucher",
            name: "代金券",
            component: () => import('../page/User/MyCoupon/Voucher.vue'),
          },
          {
            path: "Courtesy",
            name: "优惠券",
            component: () => import('../page/User/MyCoupon/Courtesy.vue'),
          },
        ]
      },
      {
        path: "MerchantserviceSet",
        name: '商家客服设置',
        component: () => import('../page/User/MerchantserviceSet/Index.vue'),
        children: [
          {
            path: "PromptSound",
            name: "消息提示音设置",
            component: () => import('../page/User/MerchantserviceSet/PromptSound.vue'),
          },
        ]
      },
      {
        path: "BankCard",
        name: '银行卡绑定',
        component: () => import('../page/User/Bankcard/Index.vue'),
        children: [
          {
            path: "SettleMent",
            name: "我的银行卡",
            component: () => import('../page/User/Bankcard/SettleMent.vue'),
          },
        ]
      },
      {
        path: "AddressManage",
        name: '地址管理',
        component: () => import('../page/User/AddressManage/Index.vue'),
        children: [
          {
            path: "MyAddress",
            name: "我的收货地址",
            component: () => import('../page/User/AddressManage/MyAddress.vue'),
          },
        ]
      },
      {
        path: "CooperationManage",
        name: '商务合作',
        component: () => import('../page/User/CooperationManage/Index.vue'),
        children: [
          {
            path: "About",
            name: "关于大事纪",
            component: () => import('../page/User/CooperationManage/About.vue'),
          },
          {
            path: "Cooperation",
            name: "招商合作",
            component: () => import('../page/User/CooperationManage/Cooperation.vue'),
          },
          {
            path: "PartnerSearch",
            name: "城市合伙人查询",
            component: () => import('../page/User/CooperationManage/PartnerSearch.vue'),
          },
          {
            path: "ApplyList",
            name: "合作申请列表",
            component: () => import('../page/User/CooperationManage/ApplyList.vue'),
          },
        ]
      },
      {
        path: "MyOrders",
        name: '我的订单',
        component: () => import('../page/User/MyOrders/Index.vue'),
        children: [
          {
            path: 'Activity',
            name: '活动',
            component: () => import('../page/User/MyOrders/Activity/Activity.vue'),
            children: [
              {
                path: '',
                name: '活动订单',
                component: () => import('../page/User/MyOrders/Activity/ActivityHome.vue'),
              },
              {
                path: 'ViewTickets',
                name: '查看票券',
                component: () => import('../page/User/MyOrders/Activity/ViewTickets.vue'),
              }
            ]
          },
          {
            path: 'Goods',
            name: '商品',
            component: () => import('../page/User/MyOrders/Goods/Goods.vue'),
            children: [
              {
                path: '',
                name: '商品订单',
                component: () => import('../page/User/MyOrders/Goods/GoodsHome.vue'),
              },
              {
                path: 'GoodsDetails',
                name: '订单详情',
                component: () => import('../page/User/MyOrders/Goods/GoodsDetails.vue'),
              },
              {
                path: 'DeliveryInformation',
                name: '物流详情',
                component: () => import('../page/User/MyOrders/Goods/DeliveryInformation.vue'),
              }
            ]
          },


        ]
      },
      {
        path: "AccountSecurity",
        name: "账号与安全",
        component: () => import('../page/User/AccountSecurity/index.vue'),
        children: [
          {
            path: "Information",
            name: "个人资料",
            component: () => import('../page/User/AccountSecurity/Information.vue'),
          },
          {
            path: "SetPassword",
            name: "密码设置",
            component: () => import('../page/User/AccountSecurity/SetPassword.vue'),
          },
          {
            path: "SetBinding",
            name: "绑定设置",
            component: () => import('../page/User/AccountSecurity/SetBinding.vue'),
          },
        ]
      },


    ]
  },


  {
    path: "/login",
    name: "登录",
    component: LoginView,
  },
  {
    path: "/404",
    name: "nofound",
    component: NoFound,
  },
  {
    path: "*",
    component: NoFound,
  },
];

export default routes;
